import { render } from "./Top.vue?vue&type=template&id=3a766e43&scoped=true&ts=true"
import script from "./Top.vue?vue&type=script&lang=ts"
export * from "./Top.vue?vue&type=script&lang=ts"

import "./Top.vue?vue&type=style&index=0&id=3a766e43&scoped=true&lang=css"

import exportComponent from "/Users/shunta/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a766e43"]])

export default __exports__